import dayjs from 'dayjs';
import Chart, { Props as ApexProps } from 'react-apexcharts';

const colors = ['#D6E4FF', '#ADC6FF', '#85A5FF', '#597EF7'];

export const buildWeeklySeries = data => {
    const accounts = data.message_members_statistic?.map(m => ({
        id: m.telegram_id,
        name: m.name,
    }));

    const labels = data.user_messages_chart?.marks.map(d =>
        dayjs(d).format('DD.MM')
    );

    try {
        const series = Object.entries(
            data.user_messages_chart?.messages || {}
        )?.map(([tg, messages]) => {
            const acc = accounts.find(a => a.id == tg.replace(/[a-z_]+/, ''));

            return {
                name: acc.name,
                messages,
            };
        });
        return {
            series,
            labels,
            accounts,
        };
    } catch (e) {
        console.error(e);
    }

    return data;
};

export const getOptions = (data): ApexProps['options'] => {
    return {
        chart: {
            toolbar: {
                show: false,
            },
        },
        legend: {
            show: true,
            position: 'left',
        },

        plotOptions: {
            heatmap: {
                radius: 5,
            },
        },
        colors: colors,
        markers: {
            colors: colors,
        },
        xaxis: {
            categories: data.labels,
        },
    };
};
